import { useRef, useEffect, FC, useState } from 'react'
import Swiper from 'swiper'
import Image from '@components/ui/image'

import Drift from 'drift-zoom'
let g_slider = null
let g_imageRef = null
let g_paneRef = null

const ThumbnailZoom: FC<any> = ({ image, aspectRatio, isPdp }) => {
  const [currentMainImage, setCurrentMainImage] = useState(image)
  let sliderRef: any = useRef(null)
  let imageRef = useRef(null)
  let paneRef = useRef(null)

  useEffect(() => {
    // let slider = new Swiper(sliderRef, {
    //   slidesPerView: 1,
    //   zoom: true,
    //   centeredSlides: true,
    //   spaceBetween: 30,
    // })

    // slider.allowTouchMove = false;
    // slider.on('slideChange', function (index) {
    //   // setCurrentSlide(this.activeIndex);
    //   if (g_imageRef && g_imageRef.length) {
    //     new Drift(g_imageRef[this.activeIndex], {
    //       paneContainer: g_paneRef,
    //     })
    //   }
    // })

    if (imageRef && imageRef.children.length) {
      g_imageRef = [...imageRef.children]
      g_paneRef = paneRef
      new Drift(imageRef.children[0], {
        paneContainer: paneRef,
        zoomFactor: 1.5,
      })
    }

    //     paneRef.classList.add('c-product-viewer__image-pane--active')
    // g_slider = slider
  }, [])

  return (
    <div style={{}} className="thumbnail-popup hidden sm:block">
      <div className="c-product-image-modal_content">
        <div className="c-product-image-modal_slider overflow-hidden">
          <div className="c-product-image-modal_slider-container">
            <div
              ref={(i) => (sliderRef = i)}
              className="swiper-container relative"
            >
              <div
                ref={(i: any) => (paneRef = i)}
                className={`z-10  absolute pointer-events-none left-0 top-0 h-full  ${
                  isPdp
                    ? 'w-[80%]  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 '
                    : 'w-full'
                }`}
              ></div>

              <div
                ref={(i: any) => (imageRef = i)}
                className="c-product-viewer__image-wrapper swiper-wrapper "
                style={{ aspectRatio, zIndex: '0' }}
              >
                <div
                  data-zoom={currentMainImage}
                  className="mt-12 min-h-[400px] w-[500px] mr-8"
                  style={{ aspectRatio }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ThumbnailZoom
